const pinkPurple = {
  color: "#FFFFFF",
  background: "#390099",
  block: {
    normal: "#FF8FA3",
    hover: "#FFB3C1",
    active: "#fa506f",
  },
  restartButton: {
    normal: "#FFBD00",
    hover: "#FFC933",
    active: "#FFBE0A",
  },
  switchButton: {
    on: "#FF758F",
    off: "#a5a5a5",
  },
};

export default {
  default: pinkPurple,
};
